
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$management-toolbar.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$management-toolbar.js';
export default __default__;
